if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("iframe, video");
      if (this.video && !this.closest(".video-carousel")) {
        this.init();
      }

      this.timeout = null;
      this.currentSrc = null;
    }

    init() {
      this.checkVideo();
      window.addEventListener("resize", () => {
        clearTimeout(this.timeout);
        setTimeout(() => {
          this.checkVideo();
        }, 200);
      });
    }

    checkVideo() {
      const isMobile = window.matchMedia(`(max-width: ${window.themeBreakpoints[this.dataset.breakMobile]}px`).matches;

      const src = this.video.dataset.mediaSrc;
      const mobileSrc = "mediaSrcMobile" in this.video.dataset ? this.video.dataset.mediaSrcMobile : src;
      const newSrc = isMobile ? mobileSrc : src;

      if (newSrc !== this.currentSrc) {
        this.currentSrc = newSrc;
        this.video.src = newSrc;
      }

      this.dataset.fillDirection = isMobile ? this.dataset.fillDirectionMobile : this.dataset.fillDirectionDesktop;
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
